import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_RoleAdminSU } from "../data.service";
import { SuRoleChangeUsersRequest } from "../SuRoleChangeUsersRequest";

@Component({
	selector: "app-role-su-role-add-users",
	templateUrl: "./role-su-role-add-users.component.html",
	styleUrls: ["./role-su-role-add-users.component.css"],
})
export class RoleSuRoleAddUsersComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_RoleAdminSU
	) {}

	ngOnInit(): void {
		this.SelectedSchool = this.dialogConfig.data.School;
		this.SelectedRole = this.dialogConfig.data.Role;

		this.RoleDesc = this.SelectedRole.RoleDesc;

		if (this.SelectedSchool.SchoolNumber != undefined) {
			this.SchoolFullName = this.SelectedSchool.SchoolNumber + " - " + this.SelectedSchool.SchoolName;
		} else {
			this.SchoolFullName = this.SelectedSchool.SchoolName;
		}

		this.loadUsers();
	}

	///////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////

	SelectedSchool: any;
	SelectedRole: any;
	RoleDesc: string = "";
	SchoolFullName: string = "";

	pagerows: any = 5;
	pagefirst: any = 0;

	cols: any = [
		{ field: "UserName", header: "Username" },
		{ field: "StaffID", header: "Staff ID" },
		{ field: "PersonName", header: "Name" },
		// { field: "SchoolName", header: "School" },
	];

	SelectedUsers: any = [];
	lstUser: any = [];

	lstSameSchoolDesc: any = [];

	errorMessage: any = "";
	UserLoading: boolean = false;
	Processing: boolean = false;

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////

	loadUsers() {
		this.errorMessage = "";
		this.UserLoading = true;
		this.SelectedUsers = [];

		var result = this.dataService.RoleAdminSuUserDialogSelectList(this.SelectedSchool.SchoolID, this.SelectedRole.RoleID);
		result.subscribe(
			(response) => {
				this.lstUser = response;

				this.lstSameSchoolDesc = Array.from(new Set(this.lstUser.map((item: any) => item.SameSchoolDesc))).sort();

				this.UserLoading = false;
			},
			(error) => {
				this.UserLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////

	onAdd() {
		this.errorMessage = "";

		if (this.SelectedUsers.length == 0) {
			this.errorMessage = "Select Users to add the role to";
			return;
		}

		var lstUIDs: number[] = [];

		lstUIDs = this.SelectedUsers.map((user) => user.UserID);

		var parms: SuRoleChangeUsersRequest = {
			SchoolID: this.SelectedSchool.SchoolID,
			RoleID: this.SelectedRole.RoleID,
			lstUserIDs: lstUIDs,
		};

		var result = this.dataService.SuRoleAddUsers(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "addusers",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Added role to " + this.SelectedUsers.length + " user" + (this.SelectedUsers.length != 1 ? "s" : "") + ".",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "addusers",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not assign role: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onCancel() {
		this.ref.close(0);
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////

	onRowSelect(val) {
		this.errorMessage = "";
	}
	onRowUnselect(val) {
		this.errorMessage = "";
	}

	///////////////////////////////////////////////////

	///////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////
	IsLoading() {
		return this.UserLoading == true || this.Processing == true;
	}
	///////////////////////////////////////////////////
}
